import { ChangeDetectorRef, Component, Inject} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyTreeNode } from 'app/modules/fuse/components/tree-view/entities/selected-company.model';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { UsuarioEmpresa } from '../../model/UsuarioEmpresa';
import { UserManagementService } from '../../services/user-management.service';
import { EmpresaService } from 'app/modules/company-view/services/empresa.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-add-edit-company',
    templateUrl: './add-edit-company.component.html',
    styleUrls: ['./add-edit-company.component.scss'],
    standalone: false
})
export class AddEditCompanyComponent {
    public companyForm: UntypedFormGroup;
    //by default IT company is selected
    public selectedEmpresaId: any = 1;
    private userAbriviation: string;
    companyName: string;

    constructor(
        private _companyTreeService: CompanyTreeViewService,
        private _cdRef: ChangeDetectorRef,
        private _userManagementService: UserManagementService,
        private _sharedService: SharedService,
        public _dialogRef: MatDialogRef<AddEditCompanyComponent>,
        public _formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA)
        private _dialogData: any,
        private empresaService: EmpresaService,
    ) {
        this.userAbriviation = _dialogData.userAbriviation;
    }

    ngAfterViewInit(): void {
        const company = new CompanyTreeNode();
        this._companyTreeService.setSelectedCompany(company);
        this._cdRef.detectChanges();
    }

    public onCompanySelcted(node: any): void {
        this.selectedEmpresaId = node.id;
    }

     public submit(): void {
      let usuarioEmpresa = new UsuarioEmpresa();
      usuarioEmpresa.Usuario = this.userAbriviation;
      usuarioEmpresa.EmpresaId = this.selectedEmpresaId;

      this._userManagementService.addUserCompany(usuarioEmpresa).subscribe(
        async (res) => {
          const datos = res.result;

          const yaExiste = datos.some((item: any) =>
            String(item.empresaId) === String(usuarioEmpresa.EmpresaId) &&
            String(item.usuario).trim().toLowerCase() === String(usuarioEmpresa.Usuario).trim().toLowerCase()
          );

          const tieneEmpresasReales = datos.some((item: any) => item.empresaId && item.empresaId !== 0);

          if (yaExiste) {
            this._sharedService.ShowSnackBar('La empresa ya está introducida');
            this.cancel(false);
          } else if (tieneEmpresasReales) {
          const empresaIds = datos.map((item: any) => item.empresaId);
          const nombres = await this.getCompanyNames(empresaIds);
            this._sharedService.ShowSnackBar(
            'Ya tiene asignada una empresa del mismo grupo: \n' + nombres.join('\n'),
            'Cerrar',
            10000 // 10 segundos
          );
            this.cancel(false);
          } else {
            this._sharedService.ShowSnackBar('Guardado con éxito');
            this.cancel(true);
          }
        },
        (err) => {
          this._sharedService.ShowSnackBar('Se produjo un error');
          console.error(err);
        }
      );
    }

    getCompanyNames(empresaIds: number[]): Promise<string[]> {
      const observables = empresaIds.map(id => this.empresaService.GetEmpresaById(id));
      return forkJoin(observables)
        .pipe(
          map(responses => responses.map(r => r.result.nombre))
        )
        .toPromise();
    }

    cancel(submitSuccess: boolean) {       
        this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
    }
}
